import styled from '@emotion/styled'

export const MfaOption = styled.div`
  display: flex;
  justify-content: stretch;
  gap: 1rem;
`
